import Dialog from '@mui/material/Dialog';
import React from 'react';
import LoadingContent from '~/components/LoadingContent';
import { useMeQuery } from '~/generated/apollo';
import getExamineeName from '~/helpers/getExamineeName';
import getIcon from '~/helpers/getIcon';
import AvatarExaminee from '../AvatarExaminee';
import { StyledDialogContent, StyledIconButton, StyledTypography } from './styles';
const IconClose = getIcon('actions.close');
export interface DialogUserDetailsProps {
  onClose: () => void;
  open: boolean;
}
export const DialogUserDetails: React.FC<DialogUserDetailsProps> = ({
  onClose,
  open
}: DialogUserDetailsProps): React.ReactElement<DialogUserDetailsProps> => {
  const {
    data: dataMe,
    loading
  } = useMeQuery();
  return <Dialog aria-label="User Details" aria-labelledby="userDetails" fullWidth maxWidth="sm" onClose={onClose} open={open} role="dialog" data-sentry-element="Dialog" data-sentry-component="DialogUserDetails" data-sentry-source-file="index.tsx">
      {/* next div is a fix for JAWS */}
      <div aria-label="User Details" id="userDetails" role='region' />
      <StyledDialogContent data-sentry-element="StyledDialogContent" data-sentry-source-file="index.tsx">
        {loading ? <LoadingContent /> : <>
            <AvatarExaminee size={200} />

            <StyledTypography variant="h3">
              {getExamineeName({
            firstName: dataMe?.me?.firstName,
            lastName: dataMe?.me?.lastName
          })}
            </StyledTypography>
          </>}

        <StyledIconButton aria-label="Close User Details Dialog" autoFocus onClick={onClose} data-sentry-element="StyledIconButton" data-sentry-source-file="index.tsx">
          <IconClose data-sentry-element="IconClose" data-sentry-source-file="index.tsx" />
        </StyledIconButton>
      </StyledDialogContent>
    </Dialog>;
};
export default DialogUserDetails;